// @core/api/endpoints/apikey/record_api_key_usage.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  RecordAPIKeyUsageRequest,
} from '../../../types/apikey';

const BASE_PATH = '/apikey';

/**
 * Record a p i key usage
 * Performs record operation on a p i key usage.
 */
export async function RecordAPIKeyUsage(
  data: RecordAPIKeyUsageRequest,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/record_api_key_usage`;
  const requestOptions = options;
  return client.post<Response>(requestPath, data, requestOptions);
}
